import api from './api';

const groupLifecycleService = {
  getStatus: async () => (await api.get('/groups/lifecycle')).data,
  setEnabled: async (enabled) => (await api.post('/groups/lifecycle/settings', { enabled })).data,
  importLinks: async (links) => (await api.post('/groups/lifecycle/import', { links })).data,
  enqueue: async (chatIds) => (await api.post('/groups/lifecycle/enqueue', { chatIds })).data,
  retry: async (id) => (await api.post(`/groups/lifecycle/${encodeURIComponent(id)}/retry`, {})).data,
};

export default groupLifecycleService;
